import { logoutReturnTo, nativeLogoutOpts } from "@/native/auth";
import { clearShareAuth } from "@/native/shareAuthMirror";
import { clearSessionQueryCaches } from "@/queryPersistence";
import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";

const Logout: React.FC = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    // Remove the Share Extension's mirrored token before the session ends.
    void clearShareAuth();
    // Wipe the persisted query cache so the next login on this browser can't
    // see this session's data.
    clearSessionQueryCaches();
    logout({
      logoutParams: { returnTo: logoutReturnTo() },
      ...nativeLogoutOpts(),
    });
  }, []);

  return null;
};

export default Logout;
